import "../scss/index.scss";

import * as bootstrap from "bootstrap";

// Bootstrap
// Note: If you want to make bootstrap globally available, e.g. for using `bootstrap.modal`
window.bootstrap = bootstrap;

window.btnScrollTop = null;

window.scrollFunction = function() {
  if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
    window.btnScrollTop.style.display = "block";
  } else {
    window.btnScrollTop.style.display = "none";
  }
}

window.topFunction = function() {
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
}

window.formSearchSubmit = function (form) {
  var url = "https://www.google.com/search?q=site%3Aulbra-to.br+" + encodeURI(form[0].value);
  window.open(url, '_blank');
  return false;
}

window.onscroll = function () { scrollFunction() };

document.addEventListener('DOMContentLoaded', function () {
  window.btnScrollTop = document.getElementById("btnScrollToTop");
})
